export enum ElementTypeEnum {
  SCRIPT = 'script',
  LINK = 'link',
}
export enum ElementPlaceEnum {
  HEAD = 'head',
  BODY = 'body',
}
